import { render, staticRenderFns } from "./CadPagExtra.vue?vue&type=template&id=2c0ae67b&"
import script from "./CadPagExtra.vue?vue&type=script&lang=js&"
export * from "./CadPagExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports